'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
/* eslint-disable no-shadow, react/require-default-props */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var input = function input() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      props = _ref.props;

  var Input = function Input(_ref2) {
    var value = _ref2.value,
        onValue = _ref2.onValue;

    var onKeyUp = function onKeyUp(_ref3) {
      var key = _ref3.key,
          value = _ref3.target.value;

      if (key === 'Enter') {
        onValue(parseValue(value));
      }
    };

    var onBlur = function onBlur(event) {
      // eslint-disable-line react/prop-types
      var value = event.target.value;

      if (event.nativeEvent.explicitOriginalTarget && event.nativeEvent.explicitOriginalTarget === event.nativeEvent.originalTarget) {
        return;
      }

      onValue(parseValue(value));
    };

    var parseValue = function parseValue(v) {
      return value === parseFloat(value) ? parseFloat(v) : v;
    };

    return _react2.default.createElement('input', _extends({
      defaultValue: value,
      onKeyUp: onKeyUp,
      onBlur: onBlur,
      autoFocus: true
    }, props));
  };

  Input.propTypes = {
    value: _propTypes2.default.any,
    onValue: _propTypes2.default.func
  };
  return Input;
};

exports.default = input;